import inViewport from '../../../../javascripts/helpers/inViewport';
import forEach from '../../../../javascripts/dom/forEach';

const stageVideoFulls = document.querySelectorAll('[data-js-module="o-stage-video-full"]');
const init = () =>
  forEach(stageVideoFulls, (index, stageVideoFull) => inViewport(stageVideoFull, 0.3));

if (stageVideoFulls.length) init();
